import { render, staticRenderFns } from "./buttonWithIcon.vue?vue&type=template&id=1a442800&scoped=true&"
import script from "./buttonWithIcon.vue?vue&type=script&lang=js&"
export * from "./buttonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./buttonWithIcon.vue?vue&type=style&index=0&id=1a442800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a442800",
  null
  
)

export default component.exports